import { useEffect } from "react";
import Constants from "common/constant";
import { InitButtonClickBlock, InitImageSetterBlock } from "./blocks";

export const Display = () => {
  useEffect(() => {
    InitButtonClickBlock();
    InitImageSetterBlock();
  }, []);

  return (
    <div className="flex-col-center gap-2 mt-8 shrink-0">
      <div className="flex-row-center gap-2">
        <div className="flex-col-center">
          <div className="flex-row-center gap-4 p-2 border-solid border-[4px] rounded-[6px] border-white/20">
            <img
              alt="*"
              src={`${Constants.assetHost}/stamps/food/1a0dfd95f4e66ae82b697271462f8cff.png`}
              className="w-[100px] h-[100px] opacity-40"
              style={{
                filter: "drop-shadow(0px 1px 3px rgba(255, 255, 255, 1))",
              }}
            />
            <p className="text text-white !text-[50px] opacity-70">→</p>
            <img
              alt="*"
              src={`${Constants.assetHost}/stamps/food/f0441f75aa862c94ed0c484b3911bd1c.png`}
              className="w-[100px] h-[100px] opacity-40"
              style={{
                filter: "drop-shadow(0px 1px 3px rgba(255, 255, 255, 1))",
              }}
            />
          </div>
          <p className="text text-white">ボックス1</p>
        </div>
      </div>

      <div className="flex-row-el flex-center shrink-0 h-[50px] relative">
        <div className="flex-row-el flex-center gap-24 upsilon z-50">
          <button
            disabled
            className="btn btn-blue"
            onPointerDown={(e) => e.stopPropagation()}
          >
            <p className="text !mb-[2px]">ボタン１</p>
          </button>
          <button
            disabled
            className="btn btn-blue"
            onPointerDown={(e) => e.stopPropagation()}
          >
            <p className="text !mb-[2px]">ボタン２</p>
          </button>
        </div>
      </div>
    </div>
  );
};
